import React from 'react';
import ReactPlayer from 'react-player';

import { getAdvancedSettings } from '../advancedSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { VideoType } from './videoConfigAggregator';
type PageBuilderVideoProps = VideoType;
import classes from './PageBuilderVideo.module.scss';

/**
 * Return the PB Video
 * @param props
 * @constructor
 */
export function PageBuilderVideo(props: PageBuilderVideoProps) {
    /**
     * Configure the styles requires for the Block
     */
    const advancedSettings = getAdvancedSettings<PageBuilderVideoProps>(props);

    const videoClassNames = ['pageBuilderVideoGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        videoClassNames.push(...props.cssClasses);
    }

    /**
     * Render the Video UI
     */
    return (
        <PageBuilderElementWrapper
            contentType={props.contentType}
            uniqueID={props.uniqueID}
            styles={{
                margin: props.margin,
                marginBottom: advancedSettings.marginBottom,
                marginLeft: advancedSettings.marginLeft,
                marginRight: advancedSettings.marginRight,
                marginTop: advancedSettings.marginTop,
                textAlign: advancedSettings.textAlign,
            }}
            classNames={videoClassNames}
        >
            <div
                className={classes['video']}
                style={{
                    padding: advancedSettings.padding,
                    paddingBottom: advancedSettings.paddingBottom,
                    paddingLeft: advancedSettings.paddingLeft,
                    paddingRight: advancedSettings.paddingRight,
                    paddingTop: advancedSettings.paddingTop,
                    borderColor: advancedSettings.borderColor,
                    borderRadius: advancedSettings.borderRadius,
                    borderStyle: advancedSettings.borderStyle,
                    borderWidth: advancedSettings.borderWidth,
                    maxWidth: props.maxWidth,
                }}
            >
                <div className={classes['videoWrapper']}>
                    <ReactPlayer
                        url={props.videoUrl}
                        controls={true}
                        className="react-player"
                        muted={props.muted}
                        width="100%"
                        height="100%"
                        config={{
                            youtube: {
                                playerVars: {
                                    autoplay: props.autoplay ? 1 : 0,
                                    rel: 0,
                                },
                            },
                        }}
                    />
                </div>
            </div>
        </PageBuilderElementWrapper>
    );
}
